import { render, staticRenderFns } from "./service.vue?vue&type=template&id=1e13bf27&scoped=true&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
import style0 from "./service.vue?vue&type=style&index=0&id=1e13bf27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e13bf27",
  null
  
)

export default component.exports